import { Component, Input, Output, EventEmitter, OnInit, OnChanges } from "@angular/core";

import { InsaCronService, AuthService } from "../../../../insa-services";
import {
    ChronosActivitiesModel,
    ImportJobDetails,
    ReportJobDetails,
    ProcessJobDetails,
    InterfaceJobDetails,
    EmailJobDetails,
    SMSJobDetails,
    TaskActivityDetails,
    ObjectCreationNotifierDetails
} from '../../../../insa-models'
import { FormBuilder, FormGroup, FormControl, Validators, EmailValidator, PatternValidator } from "@angular/forms";

@Component({
    selector: "edit-activity",
    template: require("./edit-activity.component.html")
})

export class EditActivitiesComponent implements OnInit, OnChanges{

    _jobID: number = null;
    _allActivities: any;
    _prioritiesList: Array<any>;
    //_act: ChronosActivitiesModel = new ChronosActivitiesModel();

    @Input() selectedActivityData: ChronosActivitiesModel = new ChronosActivitiesModel();
    @Input() activityTypes: Array<any>;
    @Input() set allActivities(activities: any) { this._allActivities = activities; }
    @Input() set jobID(jobId: number) { this._jobID = jobId; }
    @Input() set priorities(pl: Array<Object>){ this._prioritiesList = pl; }
    //@Input() set activityWithPostAction(act: any) { this._act = act; }
    
    @Output() addOrEditActivity: EventEmitter<ChronosActivitiesModel[]> = new EventEmitter<ChronosActivitiesModel[]>(true);
    @Output() emitActivityList: EventEmitter<ChronosActivitiesModel[]> = new EventEmitter<ChronosActivitiesModel[]>(true);
    @Output() emitIsComponentCreated: EventEmitter<any> = new EventEmitter<any>(true);
    
    interfaceJobDetails: InterfaceJobDetails = new InterfaceJobDetails();
    reportJobDetails: ReportJobDetails = new ReportJobDetails();
    importJobDetails: ImportJobDetails = new ImportJobDetails();
    processJobDetails: ProcessJobDetails = new ProcessJobDetails();
    emailJobDetails: EmailJobDetails = new EmailJobDetails();
    smsJobDetails: SMSJobDetails = new SMSJobDetails();
    taskActivityDetails: TaskActivityDetails = new TaskActivityDetails();
    objectCreationNotifierDetails: ObjectCreationNotifierDetails = new ObjectCreationNotifierDetails();

    activityID: number;
    private newActivity: ChronosActivitiesModel = new ChronosActivitiesModel();
    postAction: any;
    private report: boolean = false;
    private bankInterface: boolean = false;
    private importData: boolean = false;
    private processDetails: boolean = false;
    private sendSMS: boolean = false;
    private sendEmail: boolean = false;
    private taskActivity: boolean = false;
    private activityList = [];
    editedActivity: any;
    private submitted: boolean = false;
    private objectCreationNotifier: boolean = false;
    //activityTypes: any;
    refreshedActivityData: any;
    @Output() mermaidRenderAgain: EventEmitter<any> = new EventEmitter<any>();
    private renderMermaidAgain: boolean = false;
    
    editActivityForm = this._fb.group({
        ActivityID: new FormControl(null),
        JobID: new FormControl(null),
        ActivityTypeID: new FormControl(null),
        Description: new FormControl("", Validators.required),
        TriggerOrder: new FormControl(null),
        MaxRepeatCount: new FormControl(null, [Validators.pattern("^[0-9]+[0-9]*$"), Validators.minLength(0)]),
        RepeatDelayMinutes: new FormControl(null, [Validators.pattern("^[0-9]+[0-9]*$"), Validators.minLength(0)])
    });

    constructor(private _insaChronosService: InsaCronService, private _fb: FormBuilder, private _authService: AuthService) { }

    ngOnChanges() {
        this.activityID = this.selectedActivityData.ActivityID;
    }

    ngOnInit() {}

    selectType(typeId: number) {
        let id: number = +typeId;
        switch (id) {
            case 2: {
                this.report = true;
                this.bankInterface = false;
                this.importData = false;
                this.processDetails = false;
                this.taskActivity = false;
                this.sendEmail = false;
                this.sendSMS = false;
                this.objectCreationNotifier = false;
                this.editActivityForm.setControl("Details", new FormGroup({
                    ActivityID: new FormControl(null),
                    OptionID: new FormControl(null, Validators.required),
                    FilterID: new FormControl(null),
                    ExportDirectory: new FormControl(""),
                    IsExport: new FormControl(false),
                    //ReportID: new FormControl(null),
                    ReportSubID: new FormControl(null),
                    IsExportCSV: new FormControl(null)
                }))
                break;
            }
            case 3: {
                this.bankInterface = true;
                this.report = false;
                this.importData = false;
                this.processDetails = false;
                this.taskActivity = false;
                this.sendEmail = false;
                this.sendSMS = false;
                this.objectCreationNotifier = false;
                this.editActivityForm.setControl("Details", new FormGroup({
                    ActivityID: new FormControl(null),
                    BankID: new FormControl(null, Validators.required),
                    Download: new FormControl(false),
                    DownloadDirectory: new FormControl(""),
                    ImportHoldings: new FormControl(false),
                    ImportTransactions: new FormControl(false),
                    ImportSecurities: new FormControl(false),
                    ImportSecurityPrices: new FormControl(false),
                    ImportExchangeRates: new FormControl(false),
                    ImportClients: new FormControl(false),
                    ImportAccounts: new FormControl(false),
                    ImportRatings: new FormControl(false),
                    Process: new FormControl(false),
                    UnzipPriorToImport: new FormControl(false)
                }))
                break;
            }
            case 5: {
                this.importData = true;
                this.report = false;
                this.bankInterface = false;
                this.processDetails = false;
                this.taskActivity = false;
                this.sendEmail = false;
                this.sendSMS = false;
                this.objectCreationNotifier = false;
                this.editActivityForm.setControl("Details", new FormGroup({
                    ActivityID: new FormControl(null),
                    ImportID: new FormControl(null, Validators.required),
                    DownloadDirectory: new FormControl(""),
                    DownloadURL: new FormControl("")
                }))
                break;
            }
            case 6: {
                this.importData = false;
                this.report = false;
                this.bankInterface = false;
                this.processDetails = true;
                this.taskActivity = false;
                this.sendEmail = false;
                this.sendSMS = false;
                this.objectCreationNotifier = false;
                this.editActivityForm.setControl("Details", new FormGroup({
                    ActivityID: new FormControl(null),
                    ProcessID: new FormControl(null, Validators.required),
                    ExportDirectory: new FormControl("")
                }))
                break;
            }
            case 7:{
                this.importData = false;
                this.report = false;
                this.bankInterface = false;
                this.processDetails = false;
                this.taskActivity = true;
                this.sendEmail = false;
                this.sendSMS = false;
                this.objectCreationNotifier = false;
                this.editActivityForm.setControl("Details", new FormGroup({
                    ActivityID: new FormControl(null),
                    AssignedUserID: new FormControl(null),
                    SecAssignedUserID: new FormControl(null),
                    isPrivate: new FormControl(false),
                    TaskPriority: new FormControl(null, Validators.required),
                    Text: new FormControl("", Validators.required),
                    DueDate: new FormControl(null,  [Validators.pattern("^([0-2][0-9]{3})\/([0-1][0-9])\/([1-3][0-9]) (2[0-3]|[01]?[0-9])|:([0-5]?[0-9])$")]), //Validators.required,
                    Notes: new FormControl(""),
                    AwaitTaskCompletion: new FormControl(false),
                    DueTime: new FormControl(null, [Validators.required,  Validators.min(1), Validators.max(999)]),
                    AssignedUserList: new FormControl([])
                }))
                break;
            }
            case 8: {
                this.report = false;
                this.bankInterface = false;
                this.importData = false;
                this.processDetails = false;
                this.taskActivity = false;
                this.sendEmail = true;
                this.sendSMS = false;
                this.objectCreationNotifier = false;
                this.editActivityForm.setControl("Details", new FormGroup({
                    ActivityID: new FormControl(null),
                    EmailAddress: new FormControl("", [Validators.required, this.multiEmailValidator.bind(this)]),
                    Subject: new FormControl("", Validators.required),
                    MessageText: new FormControl("", Validators.required),
                    AttachementFileName: new FormControl(""),
                }))
                break;
            }
            case 9: {
                this.importData = false;
                this.report = false;
                this.bankInterface = false;
                this.processDetails = false;
                this.taskActivity = false;
                this.sendEmail = false;
                this.sendSMS = true;
                this.objectCreationNotifier = false;
                this.editActivityForm.setControl("Details", new FormGroup({
                    ActivityID: new FormControl(null),
                    PhoneNumber: new FormControl("", Validators.compose([Validators.required])),
                    MessageText: new FormControl("", Validators.required)
                }))
                break;
            }
            case 10: {
                this.importData = false;
                this.report = false;
                this.bankInterface = false;
                this.processDetails = false;
                this.taskActivity = false;
                this.sendEmail = false;
                this.sendSMS = false;
                this.objectCreationNotifier = true;
                this.editActivityForm.setControl("Details", new FormGroup({
                    ActivityID: new FormControl(null),
                    MonitoringObjectTypeID: new FormControl(null, Validators.required)
                }))
                break;
            }
        }
    }

    multiEmailValidator(control: FormControl): { [s: string]: boolean } {
        const emails = control.value.split(';');
        const validEmails = emails.every(email => {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return emailRegex.test(email.trim());
        });
        return validEmails ? null : { invalidemails: true };
    }

    onSubmit(editedActivity: any) {
        this.submitted = true;
        if (editedActivity.invalid) {
            return;
        }
        this.newActivity = editedActivity.value;

        this.newActivity.PostActivities = this.postAction;
        this.newActivity.JobID = this._jobID;

        this.newActivity.ActivityLastModifiedBy = this._authService.UserInfo.Name;
        

        if ((this.newActivity.JobID === null || this.newActivity.JobID === undefined) && (this.newActivity.ActivityID === null || this.newActivity.ActivityID === undefined)) {
            if (this._allActivities != null && this._allActivities != undefined) {
                this._allActivities.push(this.newActivity)
            } else {
                this._allActivities = [];
                this._allActivities.push(this.newActivity);
            }
            this.addOrEditActivity.emit(this._allActivities);
        } else if ((this.newActivity.JobID !== null || this.newActivity.JobID !== undefined) && (this.newActivity.ActivityID === null || this.newActivity.ActivityID === undefined)) {
            this._insaChronosService.addJobActivity(this.newActivity).subscribe(d => {
                if (this.newActivity.JobID !== undefined && this.newActivity.JobID !== null) this._insaChronosService.getActivityByJobId(this.newActivity.JobID).subscribe(data => { this.refreshedActivityData = data });
            });
            
        } else if ((this.newActivity.JobID !== null || this.newActivity.JobID !== undefined) && (this.newActivity.ActivityID !== null || this.newActivity.ActivityID !== undefined)) {
            this._insaChronosService.updateJobActivity(this.newActivity).subscribe(d => {
                if (this.newActivity.JobID !== undefined && this.newActivity.JobID !== null) this._insaChronosService.getActivityByJobId(this.newActivity.JobID).subscribe(data => { this.refreshedActivityData = data })
            });
        }
        //this.emitIsComponentCreated.emit(this.refreshedActivityData);
        this.emitIsComponentCreated.emit(false);
        /* Fix for overflow on body afer activity save!*/
        document.getElementsByTagName('body')[0].style.overflow = 'auto';

        //Render mermaid graph again
        this.renderMermaidAgain = true;
        this.mermaidRenderAgain.emit(this.renderMermaidAgain)
        this.renderMermaidAgain = false;
    }
}


// WEBPACK FOOTER //
// ./app/insa-components/insa-cron/insa-job/insa-job-activities-form/edit-activity.component.ts